<template>
    <div style="height: 100%">
        <v-img v-if="(error || !live) && poster" :src="poster" :aspect-ratio="16/9" width="100%" contain></v-img>
        <div v-show="live && !error" style="position:relative;" ref="container">
            <div id="jw-video"></div>
            <poll-overlay v-if="playerInstance" :player="playerInstance" ref="overlay"/>
        </div>
    </div>
</template>

<script>
    import PollOverlay from '@/components/PollOverlay';


    export default {
        name: 'VideoPlayer',
        components: { PollOverlay },
        props: {
            src: {
                type: String,
                default: '',
            },
            poster: {
                type: String,
                default: '',
            },
            live: {
                type: Boolean,
                default: false,
            },
        },
        data ()
        {
            return {
                jwplayer: window.jwplayer,
                playerInstance: null,
                error: false,
            };
        },
        watch: {
            poster ( poster )
            {
                if(this.playerInstance) {
                    this.playerInstance.load({
                        image: poster
                    })
                }
            },
          live ( live )
          {
            if(live) {
              this.init()
            } else {
              this.remove()
            }
          },
          src (  )
          {
            this.remove()
            this.init()
          },
        },
        mounted ()
        {
            if(this.live) {
                this.init()
            }
        },
        methods: {
            init()
            {
              if(!this.playerInstance)
              {
                this.playerInstance = this.jwplayer( 'jw-video' ).setup( {
                  file: this.src,
                  autostart: true,
                  height: '100%',
                  volume: 50,
                  image: this.poster,
                } );
                this.playerInstance.on( 'error', () =>
                {
                  this.retry();
                } );
                this.playerInstance.on( 'setupError', () =>
                {
                  this.retry();
                } );
                this.playerInstance.on( 'firstFrame', () =>
                {
                  this.error = false;
                } );
                this.playerInstance.on( 'ready', () =>
                {
                  //we need to move the element inside the media wrapper to assure fullscreen availability
                  let overlay = this.$refs.overlay.$el;
                  let playerElement = document.getElementsByClassName( 'jw-media' )[ 0 ];
                  playerElement.append( overlay );
                } );
              }
            },
            remove() {
                if(this.playerInstance) {
                    let overlay = this.$refs.overlay.$el;
                    let container = this.$refs.container;
                    container.append( overlay );
                    this.playerInstance.remove()
                    this.playerInstance = null
                }
            },
            retry ()
            {
                this.error = true;
                this.remove()
                setTimeout( () =>
                {
                    if ( !this.playerInstance )
                    {
                        this.init()
                    }
                }, 60000 );
            },
        },
    };
</script>

<style scoped>

    >>> .v-overlay__content {
        width: 100%;
        height: 100%;
    }

    >>> .v-overlay {
        align-items: unset;
    }
</style>